import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { fetchMe, getToken, setToken } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ok | denied

  useEffect(() => {
    if (!getToken()) {
      setStatus("denied");
      return;
    }
    fetchMe()
      .then(() => setStatus("ok"))
      .catch(() => {
        setToken(null);
        setStatus("denied");
      });
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-gold animate-spin" />
      </div>
    );
  }
  if (status === "denied") return <Navigate to="/login" replace />;
  return children;
}
